import { atom } from "recoil";

export const routeStore = atom({
	key: "routeStore",
	default: {
		currentPath: "/",
	},
});
